import { CreateClientBtpEnvUseCase } from '@/data/use-cases/clients-use-cases.js';
import { CreateClientErpEnvUseCase } from '@/data/use-cases/clients-use-cases.js';
import { CreateClientUseCase } from '@/data/use-cases/clients-use-cases.js';
import { DeleteClientBtpEnvUseCase } from '@/data/use-cases/clients-use-cases.js';
import { DeleteClientDocumentUseCase } from '@/data/use-cases/clients-use-cases.js';
import { DeleteClientErpEnvUseCase } from '@/data/use-cases/clients-use-cases.js';
import { GetClientDocumentDownloadUrlUseCase } from '@/data/use-cases/clients-use-cases.js';
import { ListClientBtpEnvsUseCase } from '@/data/use-cases/clients-use-cases.js';
import { ListClientDocumentsUseCase } from '@/data/use-cases/clients-use-cases.js';
import { ListClientErpEnvsUseCase } from '@/data/use-cases/clients-use-cases.js';
import { LoadClientByIdUseCase } from '@/data/use-cases/clients-use-cases.js';
import { LoadClientsUseCase } from '@/data/use-cases/clients-use-cases.js';
import { RemoveClientLogoUseCase } from '@/data/use-cases/clients-use-cases.js';
import { UpdateClientBtpEnvUseCase } from '@/data/use-cases/clients-use-cases.js';
import { UpdateClientErpEnvUseCase } from '@/data/use-cases/clients-use-cases.js';
import { UpdateClientUseCase } from '@/data/use-cases/clients-use-cases.js';
import { UploadClientDocumentUseCase } from '@/data/use-cases/clients-use-cases.js';
import { UploadClientLogoUseCase } from '@/data/use-cases/clients-use-cases.js';
import type { FetchHttpClient } from '@/infra/http/fetch-http-client.js';
import { ClientRepositoryImpl } from '@/infra/repositories/client-repository-impl.js';
import { ClientController } from '@/presentation/controllers/client-controller.js';

export const makeClientController = (httpClient: FetchHttpClient): ClientController => {
    const repository = new ClientRepositoryImpl(httpClient);
    return new ClientController(
        new LoadClientsUseCase(repository),
        new LoadClientByIdUseCase(repository),
        new CreateClientUseCase(repository),
        new UpdateClientUseCase(repository),
        new UploadClientLogoUseCase(repository),
        new RemoveClientLogoUseCase(repository),
        new ListClientErpEnvsUseCase(repository),
        new CreateClientErpEnvUseCase(repository),
        new UpdateClientErpEnvUseCase(repository),
        new DeleteClientErpEnvUseCase(repository),
        new ListClientBtpEnvsUseCase(repository),
        new CreateClientBtpEnvUseCase(repository),
        new UpdateClientBtpEnvUseCase(repository),
        new DeleteClientBtpEnvUseCase(repository),
        new ListClientDocumentsUseCase(repository),
        new UploadClientDocumentUseCase(repository),
        new DeleteClientDocumentUseCase(repository),
        new GetClientDocumentDownloadUrlUseCase(repository)
    );
};
